<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive datatable-vue text-center">
                        <b-modal :ref="'alertdelete' + site" title="Confirmation" @ok="onDelete()">
                            <p class="my-4">Are you sure to delete this Commande ? </p>
                        </b-modal>
                        <b-table ref="TableCommande" show-empty striped hover head-variant="light" bordered stacked="md"
                            :items="orders" :fields="tablefields" :filter="filter" :current-page="currentPage"
                            :per-page="perPage" @filtered="onFiltered">
                            <template #cell(id)="field">

                                        {{ field.item.document }}

                                </template>
                            <template #cell(paymentMethod)="field">
                                <div class="badge badge-glow badge-secondary">
                                    {{ field.item.mode_payment }}
                                </div>
                            </template>
                            <template #cell(orderStatus)="field">
                                <div>
                                    <b-form-select v-model="field.item.status" :options="OptionsOrderStatus"
                                        @change="OptionSave(field)">Order status</b-form-select>
                                </div>
                            </template>
                            <template #cell(total)="field">
                                {{ field.item.amt }}
                            </template>
                            <template #row-details="field">
                                <div class="row">
                                    <div class="col-xl-4">
                                        <ul style="text-align:left">
                                            <li>Transaction ID : {{ field.item.transactionId }}</li>
                                            <li>Firstname : {{ field.item.userDetail.firstName }}</li>
                                            <li>Lastname : {{ field.item.userDetail.lastName }}</li>
                                            <li>Phone : {{ field.item.userDetail.phone }}</li>
                                            <li>Email : {{ field.item.userDetail.email }}</li>
                                        </ul>
                                    </div>
                                    <div class="col-xl-4">
                                        <ul style="text-align:left">
                                            <li>Address : {{ field.item.userDetail.address }}</li>
                                            <li>City : {{ field.item.userDetail.city }}</li>
                                            <li>Postcode : {{ field.item.userDetail.postcode }}</li>
                                            <li>Country : {{ field.item.userDetail.country }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <b-table striped hover :items="field.item.products" :fields="DetailCommande">
                                    <template #cell(image)="item">
                                        <img height="50px" :src="item.item.image" width="50px" />
                                    </template>
                                    <template #cell(price)="item">
                                        {{ item.item.price }} {{ field.item.symbol }}
                                    </template>
                                    <template #cell(total)="item">
                                        {{ item.item.price * item.item.quantity }} {{ field.item.symbol }}
                                    </template>
                                </b-table>
                            </template>
                            <template v-slot:cell(actions)="field">
                                <div class="row-actions">
                                    <button type="button" class="icon-btn" title="View details" @click="field.toggleDetails">
                                        <feather type="eye" size="16"></feather>
                                    </button>
                                    <button type="button" class="icon-btn icon-btn-danger" title="Delete" @click="onAlert(field.item.document)">
                                        <feather type="trash-2" size="16"></feather>
                                    </button>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <b-col md="12" class="my-1 p-0 pagination-justify">
                        <b-pagination v-model="currentPage" :total-rows="orders.length" :per-page="perPage"
                            aria-controls="my-table" class="mt-4"></b-pagination>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from '@/utils/firestore-shim';
export default {
    props: ["site"],
    data() {
        return {
            selectedCommandeID: null,
            orders: [],
            value: "",
            tablefields: [
                { key: "id", label: "ORDER NUMBER", sortable: true },
                { key: "paymentMethod", label: "Payment Method", sortable: true },
                { key: "orderStatus", label: "Order status", sortable: true },
                { key: "orderDate", label: "Date order", sortable: true },
                { key: "deliveryDate", label: "Delivery Date", sortable: true },
                { key: "total", label: "Total", sortable: true },
                { key: "actions" }
            ],
            DetailCommande: [
                { key: "image", label: "Image", sortable: true },
                { key: "title", label: "Title", sortable: true },
                { key: "VariantsSelected", label: "Variant", sortable: true },
                { key: "quantity", label: "Quantity", sortable: true },
                { key: "price", label: "Price", sortable: true },
                { key: "total", label: "Total", sortable: true }
            ],
            OptionsOrderStatus: [
                { value: 'Processing', text: 'Processing' },
                { value: 'Shipped', text: 'Shipped' },
                { value: 'Delivered', text: 'Delivered' },
                { value: 'Cancelled', text: 'Cancelled' }
            ],
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 50,
            pageOptions: [10, 50, 100, 200]
        };
    },
    created() {
        this.$store.dispatch("order/getOrders");
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        }
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.orders.length;
        this.orders = this.getCommande();
    },
    methods: {
        getImgUrl(path) {
            return require("@/assets/images/dashboard/product/" + path);
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getCommande() {
            let data = [];
            let element = [];
            let ref = firebase.firestore().collection('Commandes')
                .where("mode_payment", "==", "")
                .where("site", "in", [this.site, 'www.' + this.site])
                .get()
                .then((e) => {
                    e.forEach((doc) => {
                        element = doc.data();
                        element.document = doc.id;
                        data.push(element);
                    });
                });
            return data;
        },
        async onDelete() {
            let fs = firebase.firestore();
            await fs.collection('Commandes').doc(this.selectedCommandeID).delete().then(() => {
                this.orders = this.orders.filter((e) => e.document != this.selectedCommandeID);
                this.$refs.TableCommande.refresh();
            }).catch(function (error) {
                alert(error);
            });
            this.selectedCommandeID = null;
        },
        OptionSave(doc) {
            let id = doc.item.document;
            console.log(id);
            firebase.firestore().collection('Commandes').doc(id).set(doc.item)
                .then(() => {

                })
                .catch((error) => {
                    alert(error);
                });
        },
        onAlert(doc) {
            console.log(doc);
            this.selectedCommandeID = doc;
            this.$refs['alertdelete' + this.site].show();
        }
    }
};
</script>

<style></style>